import { Route } from '@angular/router';
import { authGuard } from '../core/guards/auth.guard';

export const appRoutes: Array<Route> = [
  {
    path: 'login',
    canActivate: [authGuard],
    data: { requiresAuth: false },
    loadComponent: () =>
      import('../features/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'register',
    canActivate: [authGuard],
    data: { requiresAuth: false },
    loadComponent: () =>
      import('../features/register/register.component').then(
        (m) => m.RegisterComponent,
      ),
  },
  {
    path: 'licenses',
    canActivate: [authGuard],
    data: { requiresAuth: true },
    loadComponent: () =>
      import('../features/licenses/licenses.component').then(
        (m) => m.LicensesComponent,
      ),
  },
  {
    path: 'login/callback',
    loadComponent: () =>
      import('../features/login/callback/login-callback.component').then(
        (m) => m.LoginCallbackComponent,
      ),
  },
  {
    path: 'login/error',
    loadComponent: () =>
      import('../features/login/error/login-error.component').then(
        (m) => m.LoginErrorComponent,
      ),
  },
  {
    path: 'reset-password',
    canActivate: [authGuard],
    data: { requiresAuth: false },
    loadComponent: () =>
      import('../features/login/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent,
      ),
  },
  {
    path: 'set-password',
    canActivate: [authGuard],
    data: { requiresAuth: false },
    loadComponent: () =>
      import('../features/set-password/set-password.component').then(
        (m) => m.SetPasswordComponent,
      ),
  },
  {
    path: 'set-password-success',
    canActivate: [authGuard],
    data: { requiresAuth: false },
    loadComponent: () =>
      import('../features/set-password/set-password-success/set-password-success.component').then(
        (m) => m.SetPasswordSuccessComponent,
      ),
  },
  {
    path: 'reset-password-success',
    canActivate: [authGuard],
    data: { requiresAuth: false },
    loadComponent: () =>
      import('../features/login/reset-password-success/reset-password-success.component').then(
        (m) => m.ResetPasswordSuccessComponent,
      ),
  },
  {
    path: 'register-success',
    canActivate: [authGuard],
    data: { requiresAuth: false },
    loadComponent: () =>
      import('../features/register/register-success/register-success.component').then(
        (m) => m.RegisterSuccessComponent,
      ),
  },
  {
    path: 'validation-success',
    canActivate: [authGuard],
    data: { requiresAuth: false },
    loadComponent: () =>
      import('../features/validation-success/validation-success.component').then(
        (m) => m.ValidationSuccessComponent,
      ),
  },
  {
    path: 'silent-callback',
    loadComponent: () =>
      import('../features/silent-callback/silent-callback.component').then(
        (m) => m.SilentCallbackComponent,
      ),
  },
  {
    path: 'institutions/invitations',
    loadComponent: () =>
      import('../features/institution-invitation/redirect/institution-invitation-redirect.component').then(
        (m) => m.InstitutionInvitationRedirectComponent,
      ),
  },
  {
    path: 'institution-invitation/done',
    canActivate: [authGuard],
    data: { requiresAuth: true },
    loadComponent: () =>
      import('../features/institution-invitation/success/institution-invitation-success.component').then(
        (m) => m.InstitutionInvitationSuccessComponent,
      ),
  },
  {
    path: 'institution-invitation/error',
    canActivate: [authGuard],
    data: { requiresAuth: false },
    loadComponent: () =>
      import('../features/institution-invitation/error/institution-invitation-error.component').then(
        (m) => m.InstitutionInvitationErrorComponent,
      ),
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];
